import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';

export function cardholderNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const name = control.value;

  if (
    name !== null &&
    name !== '' &&
    name !== '' &&
    !name.match(/^[A-Za-z \-]+$/)
  ) {
    return { invalidCardHolderName: true };
  }

  return null;
}

export function middleNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const name = control.value;

  if (name !== null && name !== '' && !name.match(/^[A-Za-z]+$/)) {
    return { invalidMiddleName: true };
  }

  return null;
}

export function formAddressValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const name = control.value;

  if (name !== null && name !== '' && !name.match(/^[a-zA-Z-\s]+$/)) {
    return { invalidAddress: true };
  }

  return null;
}

export function formNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const name = control.value;

  if (name !== null && name !== '' && !name.match(/^[a-zA-Z\-\s]+$/)) {
    return { invalidName: true };
  }

  return null;
}

export function srcAcctNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    control.value !== '' &&
    !control.value.match(/^[A-Za-z0-9 \-]+$/)
  ) {
    return { invalidSrcAcctName: true };
  }

  return null;
}

export function routingNumberValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (control.value !== null && control.value !== '' && control.value !== '') {
    let n = 0;
    const aba = control.value.toString();

    for (let i = 0; i < aba.length; i += 3) {
      n +=
        parseInt(aba.charAt(i), 10) * 3 +
        parseInt(aba.charAt(i + 1), 10) * 7 +
        parseInt(aba.charAt(i + 2), 10);
    }

    if (n !== 0 && n % 10 === 0) {
      return null;
    } else {
      return { invalidRoutingNumber: true };
    }
  }

  return null;
}

export function srcAcctNumValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const srcAcctNum = control.value.toString();

  if (srcAcctNum === undefined || !srcAcctNum) {
    return null;
  }
  if (!srcAcctNum.match(/^[/*0-9]+$/)) {
    return { invalidSrcAcctNum: true };
  }
  return null;
}

export function requestingAmountValidator(fundRefund: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (fundRefund !== 'N') {
      const fundAmt = control.value.toString();
      if (fundAmt === undefined) {
        return { invalidRequestingAmountUndefined: true };
      }
      if (!fundAmt.match(/^(?=.*[1-9])\d{0,6}(?:\.\d{0,2})?$/)) {
        return { invalidRequestingAmountBadRange: true };
      }
    }
    return null;
  };
}

function newDay(day: string): string {
  let newDay = null;
  if (+day < 10) {
    newDay = '0' + day;
  } else {
    newDay = day;
  }

  return newDay;
}

function newMonth(month: string): string {
  let newMonth = null;
  if (+month < 10) {
    newMonth = '0' + month;
  } else {
    newMonth = month;
  }

  return newMonth;
}

export function dobValidator(originalDate: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    let dob = control.value;
    if (typeof dob === 'object') {
      if (dob.month !== null) {
        const constructDate =
          newMonth(dob.month) + '/' + newDay(dob.day) + '/' + dob.year;
        dob = constructDate;
      }
    }
    const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (dob === undefined || !dob) {
      return { DOBRequired: true };
    }

    const validFormat = /\d{1,2}\/\d{2}\/\d{4}/.test(dob);
    if (!validFormat) {
      return { DOBIncorrectFormat: true };
    }

    if (dob.split('/')[2] !== null && dob.split('/')[2] !== undefined) {
      if (dob.split('/')[2] === null || dob.split('/')[2] === undefined) {
        return { DOBYearRequired: true };
      }
    }

    if (dob.split('/')[0].trim().length !== 2) {
      return { DOBMonth2Digits: true };
    }

    const year = parseInt(dob.split('/')[2], 10);
    const date = parseInt(dob.split('/')[1], 10);
    const month = parseInt(dob.split('/')[0], 10);

    if (month > 12) {
      return { DOBMonthLessThanEqual12: true };
    }

    if (month === 1 || month > 2) {
      if (date > ListofDays[month - 1]) {
        return { DOBInvalidDate: true };
      }
    }

    if (month === 2) {
      let leapYear = year % 4 === 0;
      if (leapYear) {
        if (year % 100 === 0) {
          leapYear = year % 400 === 0;
        }
      }

      if (leapYear === false && date >= 29) {
        return { DOBInvalidDate: true };
      }

      if (leapYear === true && date > 29) {
        return { DOBInvalidDateLeapYear: true };
      }
    }

    return null;
  };
}

export function dobValidationErrorMessage(errorCode: string): string {
  let returnString: string;

  switch (errorCode) {
    case 'DOBIncorrectFormat':
      returnString = 'DOB must be in the format "MM/DD/YYYY"';
      break;
    case 'DOBRequired':
      returnString = 'DOB required';
      break;
    case 'DOBYearRequired':
      returnString = 'YYYY required';
      break;
    case 'DOB4DigitYear':
      returnString = 'Year must be 4 digits';
      break;
    case 'DOBYearNumeric':
      returnString = 'Year must be numeric';
      break;
    case 'DOBDayNumeric':
      returnString = 'DD must be numeric';
      break;
    case 'DOBDay2Digits':
      returnString = 'DD must have 2 digits';
      break;
    case 'DOBMonthLessThanEqual12':
      returnString = 'MM must be <=12';
      break;
    case 'DOBMonthNumeric':
      returnString = 'MM must be numeric';
      break;
    case 'DOBMonth2Digits':
      returnString = 'MM must have 2 digits';
      break;
    case 'DOBInvalidDate':
      returnString = 'Invalid DD';
      break;
    case 'DOBInvalidDateLeapYear':
      returnString = 'Invalid DD (LeapYear)';
      break;
    default:
      returnString = '';
      break;
  }

  return returnString;
}
